module.exports = __webpack_public_path__ + "static/img/developmentHistory_zh.87f3cde.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/developmentHistory_zh.jpg
// module id = DOQr
// module chunks = 1